module.exports = __webpack_public_path__ + "fonts/b46ea3d433f34f0bfa083f687949c010.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/phone.svg
// module id = 2008
// module chunks = 0